import React from "react";
import ColorButtons from "../atoms/ColorButtons";
import { useBoundStore } from "../../stores/useBoundStore";
import styled from "styled-components";

const ColorInputs = styled.div`
  height: auto;
  width: 100%;
`;

const TextColorControls = () => {
  const setTextColor = useBoundStore((state) => state.setTextColor);

  const handleTextChange = (val, color) => {
    setTextColor(color);
  };
  return (
    <ColorInputs>
      <p className="label">Text color</p>
      <ColorButtons textColor={true} clickHandler={handleTextChange} />
    </ColorInputs>
  );
};

export default TextColorControls;
